import { Outlet } from "react-router-dom";

/** Pass-through shell for the public routes. Each public page owns its own
 * chrome (header, max-width, spacing) the way the source app's route segments
 * did, so this layout only exists to satisfy makeRoute's layout/outlet shape. */
export default function PublicLayout() {
  return <Outlet />;
}
